import { render, staticRenderFns } from "./loginStaff.vue?vue&type=template&id=68021675&scoped=true"
import script from "./loginStaff.vue?vue&type=script&lang=js"
export * from "./loginStaff.vue?vue&type=script&lang=js"
import style0 from "./loginStaff.vue?vue&type=style&index=0&id=68021675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68021675",
  null
  
)

export default component.exports